import React from 'react';
import { Layout } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { SidebarNavItem } from './SidebarNavItem';

const { Sider } = Layout;

interface MenuItem {
  key: string;
  icon: React.ReactNode;
  label: string;
  path: string;
}

interface SidebarProps {
  collapsed: boolean;
  menuItems: MenuItem[];
  currentPath: string;
  onLogout: () => void;
}

const LogoIcon = () => (
  <div className="admin-sidebar-logo-icon">
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
    </svg>
  </div>
);

export const Sidebar: React.FC<SidebarProps> = ({
  collapsed,
  menuItems,
  currentPath,
  onLogout,
}) => {
  const mainItems = menuItems.filter(item => item.path !== '/settings');
  const settingsItem = menuItems.find(item => item.path === '/settings');

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      width={240}
      collapsedWidth={64}
      className="admin-sidebar"
      style={{
        overflow: 'auto',
        height: '100vh',
        position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0,
      }}
    >
      <div className="admin-sidebar-logo">
        <LogoIcon />
        {!collapsed && (
          <div className="admin-sidebar-logo-text">
            <span className="admin-sidebar-logo-title">F&B Admin</span>
            <span className="admin-sidebar-logo-sub">CRM Portal</span>
          </div>
        )}
      </div>
      <nav className="admin-sidebar-nav">
        {mainItems.map(item => (
          <SidebarNavItem
            key={item.key}
            icon={item.icon}
            label={item.label}
            path={item.path}
            collapsed={collapsed}
          />
        ))}
      </nav>
      <div className="admin-sidebar-bottom">
        {settingsItem && (
          <SidebarNavItem
            key={settingsItem.key}
            icon={settingsItem.icon}
            label={settingsItem.label}
            path={settingsItem.path}
            collapsed={collapsed}
          />
        )}
        <SidebarNavItem
          key="logout"
          icon={<LogoutOutlined />}
          label="Logout"
          path=""
          collapsed={collapsed}
          isLogout
          onLogout={onLogout}
        />
      </div>
    </Sider>
  );
};
